document.addEventListener("DOMContentLoaded", function () {

    const measurement = document.querySelector(".cc-size-measurement");

    if (!measurement) return;

    const productType = measurement.dataset.productType;

    const DATA = {

        coords: {
            XS: "33 in",
            S: "35 in",
            M: "37 in",
            L: "39 in",
            XL: "41.5 in",
            XXL: "44.5 in",
            "2XL": "44.5 in",
            "3XL": "47.5 in",
            "4XL": "51.5 in"
        },

        suits: {
            XS: "33 in",
            S: "35 in",
            M: "37 in",
            L: "39 in",
            XL: "41.5 in",
            XXL: "44.5 in",
            "2XL": "44.5 in",
            "3XL": "47.5 in",
            "4XL": "51.5 in"
        },

        kurtas: {
            XS: "33 in",
            S: "35 in",
            M: "37 in",
            L: "39 in",
            XL: "41.5 in",
            XXL: "44.5 in",
            "2XL": "44.5 in",
            "3XL": "47.5 in",
            "4XL": "51.5 in"
        },

        shortkurtis: {
            XS: "37 in",
            S: "38.5 in",
            M: "40.5 in",
            L: "42.5 in",
            XL: "45.5 in",
            XXL: "48 in",
            "2XL": "48 in",
            "3XL": "50 in",
            "4XL": "52 in"
        }

    };

    function updateMeasurement() {

        const fieldsets = document.querySelectorAll(".variant-input-wrap");

        let selectedSize = null;

        fieldsets.forEach(function(fieldset){

            const name = (fieldset.getAttribute("name") || "").toLowerCase();

            if(name.includes("size")){

                const checked = fieldset.querySelector("input[type='radio']:checked");

                if(checked){
                    selectedSize = checked.value.trim();
                }

            }

        });

        if(!selectedSize) return;

        const value =
            DATA[productType] &&
            DATA[productType][selectedSize];

        measurement.innerHTML = `
    <span class="cc-size-label">Size:</span>
    <span class="cc-size-value">${selectedSize}</span>

    <span style="margin:0 8px;color:#ccc;">|</span>

    <span class="cc-size-label">Your Bust:</span>
    <span class="cc-size-value">${value || "--"}</span>
`;

    }

    document.body.addEventListener("change", function(e){

        if(e.target.matches("input[data-variant-input]")){
            setTimeout(updateMeasurement,50);
        }

    });

    window.addEventListener("variant:change", function(){
        setTimeout(updateMeasurement,50);
    });

    setTimeout(updateMeasurement,300);

});